import { typeCalendar } from "../HomeApi";
import momentTz from "moment-timezone";

/**
 * Get the opening and closing hours for the form chosen date
 * @returns Return opening hours and closing hours
 */
export const getCalendarOperatingHoursForADay = (
  startDateTimeUtc: string,
  calendar: typeCalendar
) => {
  const startDate = momentTz(startDateTimeUtc).tz("Asia/Singapore");

  // Get the starting hours
  const todayOpeningHours = calendar.openHours.find((openHour) => {
    if (openHour.day === startDate.day() && openHour.endTime === "23:55:00") {
      return true;
    } else {
      return false;
    }
  });

  if (todayOpeningHours) {
    const [todayHour, todayMinute, todaySeconds] =
      todayOpeningHours.startTime.split(":");

    startDate.hours(parseInt(todayHour));
    startDate.minutes(parseInt(todayMinute));
  }

  // Get closing hours which normally spill over to next day
  const nextDayClosingHours = calendar.openHours.find((openHour) => {
    if (
      openHour.day === (startDate.day() + 1) % 7 &&
      openHour.startTime === "00:00:00"
    ) {
      return true;
    } else {
      return false;
    }
  });

  let endDate = momentTz(startDateTimeUtc).tz("Asia/Singapore");
  if (nextDayClosingHours) {
    const [endHour, endMinute, endSeconds] =
      nextDayClosingHours.endTime.split(":");
    endDate.hours(parseInt(endHour));
    endDate.minutes(parseInt(endMinute));
    endDate = endDate.add(1, "day");
  }

  return {
    startTime: startDate.format(),
    endTime: endDate.format(),
  };
};
